import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation, Route } from 'react-router-dom';
// layouts
import MainLayout from '../layouts/main';
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// guards
import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
import RegisterGuard from '../guards/RegisterGuard';

// import RoleBasedGuard from '../guards/RoleBasedGuard';
// config
import { PATH_AFTER_LOGIN } from '../config';
// components
import LoadingScreen from '../components/LoadingScreen';
// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};


export default function Router() {
  return useRoutes([
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <RegisterGuard>
              <Register />
            </RegisterGuard>
          ),
        },
        // { path: 'login-unprotected', element: <Login /> },
        // { path: 'register-unprotected', element: <Register /> },
        { path: 'reset-password', element: <ResetPassword /> },
        { path: 'new-password', element: <NewPassword /> },
        { path: 'verify-email', element: <VerifyEmail /> },
        { path: 'verify-service', element: <VerifyService /> },
        { path: 'resend-verification', element: <ResendVerification /> },
        // { path: 'resend-service-verification', element: <ResendServiceVerification /> },
        { path: 'verification-required', element: <VerificationRequired /> },
        // { path: 'verify', element: <VerifyCode /> },
        // { path: 'verification', element: <VerifyCode /> },
        // { path: 'learn-more', element: <LearnMore /> },
        
        { path: 'add-service', element: <AddServiceInitial /> },

      ],
    },
    { path: 'chat', element: <LiveChat /> },
    // Dashboard Routes
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <GeneralApp /> },
        { path: 'addservice', element: <AddService /> },
        { path: 'addotherservice/:accountId', element: <AddServiceOthersLinked /> },
        // { path: 'ecommerce', element: <GeneralEcommerce /> },
        // { path: 'analytics', element: <GeneralAnalytics /> },
        // { path: 'banking', element: <GeneralBanking /> },
        // { path: 'booking', element: <GeneralBooking /> },

        // {
        //   path: 'e-commerce',
        //   children: [
        //     { element: <Navigate to="/dashboard/e-commerce/shop" replace />, index: true },
        //     { path: 'shop', element: <EcommerceShop /> },
        //     { path: 'product/:name', element: <EcommerceProductDetails /> },
        //     { path: 'list', element: <EcommerceProductList /> },
        //     { path: 'product/new', element: <EcommerceProductCreate /> },
        //     { path: 'product/:name/edit', element: <EcommerceProductCreate /> },
        //     { path: 'checkout', element: <EcommerceCheckout /> },
        //     { path: 'invoice', element: <EcommerceInvoice /> },
        //   ],
        // },
        {
          path: 'user',
          children: [
            // { element: <Navigate to="/dashboard/user/profile" replace />, index: true },
            // { path: 'profile', element: <UserProfile /> },
            // { path: 'cards', element: <UserCards /> },
            // { path: 'list', element: <UserList /> },
            // { path: 'new', element: <UserCreate /> },
            // { path: ':name/edit', element: <UserCreate /> },
            { path: 'account', element: <UserAccount /> },
          ],
        },
        // {
        //   path: 'blog',
        //   children: [
        //     { element: <Navigate to="/dashboard/blog/posts" replace />, index: true },
        //     { path: 'posts', element: <BlogPosts /> },
        //     { path: 'post/:title', element: <BlogPost /> },
        //     { path: 'new-post', element: <BlogNewPost /> },
        //   ],
        // },
        // {
        //   path: 'mail',
        //   children: [
        //     { element: <Navigate to="/dashboard/mail/all" replace />, index: true },
        //     { path: 'label/:customLabel', element: <Mail /> },
        //     { path: 'label/:customLabel/:mailId', element: <Mail /> },
        //     { path: ':systemLabel', element: <Mail /> },
        //     { path: ':systemLabel/:mailId', element: <Mail /> },
        //   ],
        // },
        // {
        //   path: 'chat',
        //   children: [
        //     { element: <Chat />, index: true },
        //     { path: 'new', element: <Chat /> },
        //     { path: ':conversationKey', element: <Chat /> },
        //   ],
        // },
        // { path: 'calendar', element: <Calendar /> },
        // { path: 'kanban', element: <Kanban /> },

        // Selfcare Routes
        { path: 'service', element: <ServiceGeneral /> },
        { path: 'payments', element: <PaymentHistory /> },
        { path: 'bills', element: <AccountBilling /> },
        { path: 'bills/pay', element: <CheckoutBills /> },
        // { path: 'bills/pay/mycash', element: <MyCashPayment /> },
        // { path: 'topup/pay/mycash', element: <MyCashTopup /> },
        { path: 'bills/pay/result', element: <BillResultCheck /> },
        { path: 'topup/pay', element: <TopupCheckout /> },
        { path: 'topup/pay/result', element: <TopupCheckResult /> },
        { path: 'account', element: <AccountSummary /> },
        { path: 'contact', element: <ContactInfo /> },
        { path: 'home', element: <Home /> },
        { path: 'topup', element: <ServiceAddon /> },
        { path: 'serviceTopup', element: <ServiceAddonOld /> },
        { path: 'accessdenied', element: <AccessDenied /> },
        { path: 'maintenance', element: <Maintenance /> },
        { path: '500', element: <Page500 /> },
        { path: '400', element: <Service404 /> },




      ],
    },

    // Main Routes
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        // { path: 'coming-soon', element: <ComingSoon /> },
        { path: 'maintenance', element: <Maintenance /> },
        // { path: 'pricing', element: <Pricing /> },
        // { path: 'payment', element: <Payment /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    {
      path: '*',
      children: [
        { path: 'billPay/Mobile/myTelecom', element: <CheckoutBills /> },
        { path: 'buyTopup/Mobile/myTelecom', element: <TopupCheckout /> },
        { path: 'bills/pay/result/', element: <BillResultCheck /> },
        { path: 'topup/pay/result', element: <TopupCheckResult /> },
        { path: 'topup/pay/mycash', element: <MyCashTopup /> },
        { path: 'bills/pay/mycash', element: <MyCashPayment /> },
      ],
    },
    // {
    //   path: '/',
    //   element: <MainLayout />,
    //   children: [
    //     { element: <HomePage />, index: true },
    //     { path: 'about-us', element: <About /> },
    //     { path: 'contact-us', element: <Contact /> },
    //     { path: 'faqs', element: <Faqs /> },
    //   ],
    // },
    {
      path: '/',
      element: 
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>,
      children: [
        { element: <GeneralApp />, index: true },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

// IMPORT COMPONENTS

// Authentication
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const LearnMore = Loadable(lazy(() => import('../pages/auth/LearnMore')));
const AddServiceInitial = Loadable(lazy(() => import('../pages/auth/AddServiceInitial')));
const LoginConnect = Loadable(lazy(() => import('../pages/auth/LoginConnect')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const LiveChat = Loadable(lazy(() => import('../pages/Chat')));
const VerifyService = Loadable(lazy(() => import('../pages/auth/VerifyService')));
const ResendVerification = Loadable(lazy(() => import('../pages/auth/ResendVerification')));
const ResendServiceVerification = Loadable(lazy(() => import('../pages/auth/ResendServiceVerification')));
const NewPassword = Loadable(lazy(() => import('../pages/auth/NewPassword')));
const VerifyEmail = Loadable(lazy(() => import('../pages/auth/VerifyEmail')));
const VerificationRequired = Loadable(lazy(() => import('../pages/auth/VerificationRequired')));
const VerifyCode = Loadable(lazy(() => import('../pages/auth/VerifyCode')));
// Dashboard
const GeneralApp = Loadable(lazy(() => import('../pages/dashboard/GeneralApp')));
const AddService = Loadable(lazy(() => import('../pages/dashboard/AddService')));
const AddServiceOthersLinked = Loadable(lazy(() => import('../pages/dashboard/AddServiceOthersLinked')));
const GeneralEcommerce = Loadable(lazy(() => import('../pages/dashboard/GeneralEcommerce')));
const GeneralAnalytics = Loadable(lazy(() => import('../pages/dashboard/GeneralAnalytics')));
const GeneralBanking = Loadable(lazy(() => import('../pages/dashboard/GeneralBanking')));
const GeneralBooking = Loadable(lazy(() => import('../pages/dashboard/GeneralBooking')));
const EcommerceShop = Loadable(lazy(() => import('../pages/dashboard/EcommerceShop')));
const EcommerceProductDetails = Loadable(lazy(() => import('../pages/dashboard/EcommerceProductDetails')));
const EcommerceProductList = Loadable(lazy(() => import('../pages/dashboard/EcommerceProductList')));
const EcommerceProductCreate = Loadable(lazy(() => import('../pages/dashboard/EcommerceProductCreate')));
const EcommerceCheckout = Loadable(lazy(() => import('../pages/dashboard/EcommerceCheckout')));
const EcommerceInvoice = Loadable(lazy(() => import('../pages/dashboard/EcommerceInvoice')));
const BlogPosts = Loadable(lazy(() => import('../pages/dashboard/BlogPosts')));
const BlogPost = Loadable(lazy(() => import('../pages/dashboard/BlogPost')));
const BlogNewPost = Loadable(lazy(() => import('../pages/dashboard/BlogNewPost')));
const UserProfile = Loadable(lazy(() => import('../pages/dashboard/UserProfile')));
const UserCards = Loadable(lazy(() => import('../pages/dashboard/UserCards')));
const UserList = Loadable(lazy(() => import('../pages/dashboard/UserList')));
const UserAccount = Loadable(lazy(() => import('../pages/dashboard/UserAccount')));
const UserCreate = Loadable(lazy(() => import('../pages/dashboard/UserCreate')));
const Chat = Loadable(lazy(() => import('../pages/dashboard/Chat')));
const Mail = Loadable(lazy(() => import('../pages/dashboard/Mail')));
const Calendar = Loadable(lazy(() => import('../pages/dashboard/Calendar')));
const Kanban = Loadable(lazy(() => import('../pages/dashboard/Kanban')));
// Main
const HomePage = Loadable(lazy(() => import('../pages/Home')));
const About = Loadable(lazy(() => import('../pages/About')));
const Contact = Loadable(lazy(() => import('../pages/Contact')));
const Faqs = Loadable(lazy(() => import('../pages/Faqs')));
const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')));
const Maintenance = Loadable(lazy(() => import('../pages/Maintenance')));
const AccessDenied = Loadable(lazy(() => import('../pages/AccessDenied')));
const Pricing = Loadable(lazy(() => import('../pages/Pricing')));
const Payment = Loadable(lazy(() => import('../pages/Payment')));
const Page500 = Loadable(lazy(() => import('../pages/Page500')));
const NotFound = Loadable(lazy(() => import('../pages/Page404')));
const Service404 = Loadable(lazy(() => import('../pages/Service404')));
// Selfcare  
const ServiceGeneral = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/serviceInfo/ServiceSummary')));
const PaymentHistory = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/payment/PaymentHistory')));
const AccountBilling = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/bill/AccountBilling')));
const CheckoutBills = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/bill/billpay/CheckoutBills')));
const MyCashPayment = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/bill/billpay/mycash/OTPMyCash')));
const BillResultCheck = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/bill/billpay/billCheck/BillResultCheck')));
const AccountSummary = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/accountInfo/AccountSummary')));
const ContactInfo = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/contact/Contact')));
const Home = Loadable(lazy(() => import('../pages/dashboard/GeneralApp')));
const ServiceAddonOld = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/topup/oldTopup/ServiceAddonOld')));
const ServiceAddon = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/topup/ServiceAddon')));
const TopupCheckout = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/topup/onlineTopup/TopupCheckout')))
const TopupCheckResult = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/topup/onlineTopup/topupCheck/TopupCheckResult')))
const MyCashTopup = Loadable(lazy(() => import('../sections/@dashboard/user/myTelecom/topup/onlineTopup/mycash/OTPMyCash')));


